import React, { Component } from 'react';

class ButtonBorderNexcareDefault extends Component {
    render() {
        return (
            <button
                type={this.props.type}
                id={this.props.id}
                onClick={this.props.onClick}
                className={`${this.props.className} bg-transparent rounded-md border border-nexcaredefault text-nexcaredefault focus:outline-none font-medium px-6 py-2`}
                style={this.props.style}
            >
                {this.props.children}
            </button>
        );
    }
}

export default ButtonBorderNexcareDefault;